import { Modal } from "@mallardbay/lib-react-components"
import React from "react"

import COPY from "~config/copy-constants"
import Form from "~components/shared/hook-form/core/form"
import ModalButtons from "~components/shared/modal-buttons"
import {
    getInitialRequestQuoteFormValues,
    getRequestQuoteFormSchema,
    useHandleFormSubmit,
} from "~components/shared/request-quote-modal/request-quote-form-helpers"
import type {
    ListingFieldsFragment,
    PublicListingFieldsFragment,
    UserFieldsFragment,
} from "~graphql/generated/graphql"
import RequestQuoteInputs from "~components/shared/request-quote-modal/request-quote-inputs"

interface Props {
    readonly isOpen: boolean
    readonly onClose: () => void
    // TODO: make optional and add listing selector
    readonly listing: PublicListingFieldsFragment | ListingFieldsFragment
    readonly user?: UserFieldsFragment | null
}

export default function RequestQuoteModal({
    isOpen,
    onClose,
    listing,
    user,
}: Props) {
    const schema = getRequestQuoteFormSchema()
    const defaultValues = getInitialRequestQuoteFormValues({
        listing,
        user,
    })
    const { handleSubmit, isLoadingSubmit } = useHandleFormSubmit({
        onSuccess: onClose,
    })

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title={COPY.REQUEST_A_QUOTE}
            shouldAddPadding
        >
            <Form
                schema={schema}
                defaultValues={defaultValues}
                onSubmit={handleSubmit}
            >
                <RequestQuoteInputs listing={listing} />
                <ModalButtons
                    isFormSubmit
                    isLoading={isLoadingSubmit}
                    onCancel={onClose}
                    showCancelButton={false}
                    submitButtonLabel={COPY.SUBMIT}
                />
            </Form>
        </Modal>
    )
}
